<template>
  <div style="height: 100%; overflow: auto;">
    <div class="v-data-table-off-overflow" v-if="isLoaded">
      <v-data-table
        v-if="view === 'table1'"
        dense
        :items="table.items"
        :headers="table.headers"
        disable-pagination
        hide-default-footer
        fixed-header
      >
        <template #[`item.name`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-sheet
                color="transparent"
                height="100%"
                class="name-cell name"
                v-on="on" v-bind="attrs"
              >
                <span class="sliced-name">{{ item.name }}</span>
              </v-sheet>
            </template>
            <span>{{ item.name }}</span>
          </v-tooltip>
        </template>
        <template #[`item.rebuke`]="{ item }">
          <v-sheet
            :color="getColorRebuke(item.rebuke)"
            height="100%"
            class="name-cell pl-2"
          >
            {{ item.rebuke }}%
          </v-sheet>
        </template>
      </v-data-table>

      <apexchart
        v-show="view === 'graph1' && isApexReady"
        :options="chartOptions"
        :series="series"
        :height="apexHeight"
      />
    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EmploymentWidget',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      table: {
        items: [],
        headers: [
          {text: 'имя', value: 'name'},
          {text: 'время работы', value: 'time'},
          {text: 'время разговора', value: 'talk'},
          {text: 'загрузка', value: 'rebuke'},
        ],
      },

      chartOptions: {
        legend: {
          show: false,
        },
        chart: {
          type: 'bar',
          background: '#00000000',
          height: 300,
          toolbar: {
            show: false
          },
        },
        plotOptions: {
          bar: {
            barHeight: '100%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        colors: [],
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#fff']
          },
          formatter(val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
          },
          offsetX: 0,
          dropShadow: {
            enabled: false
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          theme: 'dark',
          custom: this.tooltip,
          // x: {
          //   show: false
          // },
          // y: {
          //   title: {
          //     formatter: function (val, opt) {
          //       return opt.w.globals.labels[opt.dataPointIndex]
          //     }
          //   }
          // }
        },
        title: {
          show: false,
            // text: 'Длительность разговоров за сегодня',
            // align: 'center',
            // floating: true
        },
        theme: {
            mode: 'light', 
        },

      },
      series: [{
        data: []
      }],
      itemsCopy: [],
      isApexReady: false,
      apexHeight: 300,
      isLoaded: false,
    }
  },

  computed: {
    ...mapGetters({
    }),

    isDarkTheme() {
      return this.$vuetify.theme.isDark;
    },

  },

  watch: {
    isDarkTheme() {
      this.changeApexTheme();
    },
  },

  methods: {
    ...mapActions({
      loadEmploymentWidget: 'dashboard/loadEmploymentWidget',
    }),

    tooltip({dataPointIndex}) {
      let rebuke = this.itemsCopy[dataPointIndex].rebuke;
      let name = this.itemsCopy[dataPointIndex].name;

      return `<div class="apexcharts-tooltip-rangebar">
        <span>
          ${name} <br>
          Загрузка ${rebuke}%
        </span>
      </div>`;
    },

    getColorRebuke(r) {
      let clr;
      if (r < 30) clr = '#F4433620';
      if (r >= 30 && r < 50) clr = '#FF980020';
      if (r >= 50) clr = '#4CAF5020';

      return clr
    },

    fillApexData() {
      this.table.items.sort((a, b) => {
        if (a.rebuke >= b.rebuke) return 1
        return -1
      })

      this.itemsCopy = window.structuredClone(this.table.items
        .map(item => item)
      );

      this.chartOptions.xaxis.categories = 
        this.table.items.flatMap(item => item.name);

      this.series[0].data = 
        this.table.items.flatMap(item => item.talk)
          // .sort((a, b) => a <= b);

      this.chartOptions.xaxis.max = Math.max(...this.series[0].data) + 10;

      let apexHeight = this.table.items.length * 25;
      if (apexHeight > 300) this.apexHeight = apexHeight;

      let rebukes = this.table.items.flatMap(item => item.rebuke);
      rebukes.forEach(r => {
        let clr = '';
        if (r < 30) clr = '#FF1744';
        if (r >= 30 && r < 50) clr = '#F9A825';
        if (r >= 50) clr = '#4CAF50';
        this.chartOptions.colors.push(clr);
      })

      this.isApexReady = true;
    },

    changeApexTheme() {
      if (this.isDarkTheme) {
        this.chartOptions = {
          chart: {
            background: '#00000000'
          },
          theme: {
            mode: 'dark',
          },
          dataLabels: {
            style: {
              colors: ['#fff']
            }
          }
        };
      } else {
        this.chartOptions = {
          chart: {
            background: '#00000000'
          },
          theme: {
            mode: 'light',
          },
          dataLabels: {
            style: {
              colors: ['#222']
            }
          }
        };
      }
    },

    async loadData() {
      this.isLoaded = false;
      this.table.items = await this.loadEmploymentWidget(this.widget.params);
      this.fillApexData();
      this.isLoaded = true;
    },
  },
  
  async mounted() {
    await this.loadData();
    this.changeApexTheme();
  },
}
</script>


<style scoped lang="scss">
.colorfull_cell {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;

  &.green {
    background-color: #4CAF5040 !important;
  }
  &.red {
    background-color: #F4433640 !important;
  }
}
.name-cell {
  display: grid;
  align-items: center;
  padding-left:0.2rem;
  padding-right:0.2rem;

  &.name {
    min-width: 120px;
    width: 100%;
  }

  .sliced-name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>